import { render, staticRenderFns } from "./HeightField.vue?vue&type=template&id=281b36c9&"
import script from "./HeightField.vue?vue&type=script&lang=js&"
export * from "./HeightField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports